import { Input } from "@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { STATES } from "@/lib/constants"
import { ValidationError } from "../form/ValidationError"

interface MailRecipientInfoProps {
  formData: {
    firstName: string
    lastName: string
    email: string
    streetAddress: string
    unit: string
    city: string
    state: string
    zipCode: string
  }
  handleInputChange: (field: string, value: string) => void
  showErrors: boolean
}

export function MailRecipientInfoStep({ formData, handleInputChange, showErrors }: MailRecipientInfoProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1 text-[#18375d]">
            First Name <span className="text-[#ea384c]">*</span>
          </label>
          <Input
            value={formData.firstName}
            onChange={(e) => handleInputChange("firstName", e.target.value)}
            placeholder="First Name"
            className={showErrors && !formData.firstName ? "border-[#ea384c]" : ""}
          />
          {showErrors && !formData.firstName && (
            <ValidationError message="First name cannot be blank" />
          )}
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-[#18375d]">
            Last Name <span className="text-[#ea384c]">*</span>
          </label>
          <Input
            value={formData.lastName}
            onChange={(e) => handleInputChange("lastName", e.target.value)}
            placeholder="Last Name"
            className={showErrors && !formData.lastName ? "border-[#ea384c]" : ""}
          />
          {showErrors && !formData.lastName && (
            <ValidationError message="Last name cannot be blank" />
          )}
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1 text-[#18375d]">
          Email
        </label>
        <Input
          type="email"
          value={formData.email}
          onChange={(e) => handleInputChange("email", e.target.value)}
          placeholder="Email Address (Optional)"
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1 text-[#18375d]">
          Street Address <span className="text-[#ea384c]">*</span>
        </label>
        <Input
          value={formData.streetAddress}
          onChange={(e) => handleInputChange("streetAddress", e.target.value)}
          placeholder="Street Address"
          className={showErrors && !formData.streetAddress ? "border-[#ea384c]" : ""}
        />
        {showErrors && !formData.streetAddress && (
          <ValidationError message="Street address cannot be blank" />
        )}
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1 text-[#18375d]">
            Apartment/Suite/Unit
          </label>
          <Input
            value={formData.unit}
            onChange={(e) => handleInputChange("unit", e.target.value)}
            placeholder="Apt, Suite, etc. (Optional)"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-[#18375d]">
            City <span className="text-[#ea384c]">*</span>
          </label>
          <Input
            value={formData.city}
            onChange={(e) => handleInputChange("city", e.target.value)}
            placeholder="City"
            className={showErrors && !formData.city ? "border-[#ea384c]" : ""}
          />
          {showErrors && !formData.city && (
            <ValidationError message="City cannot be blank" />
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1 text-[#18375d]">
            State <span className="text-[#ea384c]">*</span>
          </label>
          <Select
            value={formData.state}
            onValueChange={(value) => handleInputChange("state", value)}
          >
            <SelectTrigger className={showErrors && !formData.state ? "border-[#ea384c]" : ""}>
              <SelectValue placeholder="Select a state" />
            </SelectTrigger>
            <SelectContent>
              {STATES.map(state => (
                <SelectItem key={state.value} value={state.value}>
                  {state.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {showErrors && !formData.state && (
            <ValidationError message="State cannot be blank" />
          )}
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 text-[#18375d]">
            ZIP Code <span className="text-[#ea384c]">*</span>
          </label>
          <Input
            value={formData.zipCode}
            onChange={(e) => handleInputChange("zipCode", e.target.value)}
            placeholder="ZIP Code"
            className={showErrors && !formData.zipCode ? "border-[#ea384c]" : ""}
          />
          {showErrors && !formData.zipCode && (
            <ValidationError message="ZIP code cannot be blank" />
          )}
        </div>
      </div>
    </div>
  )
}